module.exports = __webpack_public_path__ + "static/media/road.225ef6e7.svg";